<template>
  <div ref="container">
    <a-modal :title="title" :width="800" :visible="visible" :getContainer="() => $refs.container" :maskStyle="{'top':'93px','left':'154px'}" :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()" :maskClosable="false" @cancel="handleCancel" cancelText="关闭" style="top:20px;">
      <template slot="footer">
        <a-button key="back" v-if="!uuid" type="primary" @click="submit">确认</a-button>
        <a-button key="back" @click="handleCancel">关闭</a-button>
      </template>
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
      </div>
      <!-- table区域-begin -->
      <a-table bordered ref="table" size="middle" :pagination="false" rowKey="id" :columns="columns" :dataSource="dataSource" :loading="loading" @change="handleTableChange">
        <span slot="packType" slot-scope="text, record">
          <span>{{record.packType}}级包装</span>
        </span>
      </a-table>
      <!-- table区域-end -->
      <!-- 表单区域 -->
      <!-- <bill-detail ref="billDetail"></bill-detail> -->
    </a-modal>
  </div>
</template>
<script>
// import BillDetail from '../../bill/dialog/BillDetail'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JEllipsis from '@/components/jeecg/JEllipsis'
import { findBillDetailByNumber, submitto, gatherDetails } from '@/api/api'
import { openDownloadDialog, sheet2blob } from '@/utils/util'
import { mixinDevice } from '@/utils/mixin'

export default {
  name: 'MaterialInOutList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    // BillDetail,
    JEllipsis,
  },
  data() {
    return {
      loading: false,
      title: '操作',
      visible: false,
      disableMixinCreated: false,
      toFromType: '',
      currentMaterialId: '',
      dataSource: [],
      fileName: '',
      uuid: '',
      // 表头
      columns: [
        // { title: '批号', dataIndex: 'batchNumber', width: 100 },
        { title: '产品DI', dataIndex: 'di', width: 100 },
        { title: '包装级别', dataIndex: 'packType', width: 100, scopedSlots: { customRender: 'packType' } },
        { title: '包装数量', dataIndex: 'counts', width: 200 },
      ],
      labelCol: {
        xs: { span: 1 },
        sm: { span: 2 },
      },
      wrapperCol: {
        xs: { span: 10 },
        sm: { span: 16 },
      },
    }
  },
  created() {},
  methods: {
    // 提交
    async submit() {
      console.log(this.dataSource, 'dataSource')
      console.log(this.fileName, 'fileName')
      console.log(this.$store.getters.userInfo.id, 'this.$store.getters.userInfo.id')
      let obj = {
        batchNumber: this.dataSource[0].batchNumber,
        version: this.dataSource[0].version,
        di: this.dataSource[0].di,
        fileName: this.fileName,
      }
      this.loading = true
      const res = await submitto(obj)
      console.log(res, 'res')
      if (res.code == 200) {
        this.visible = false
        this.$message.success('操作成功')
        this.close()
        this.loading = false
      } else {
        this.$message.success(res.data)
      }
    },
    // getQueryParams() {
    //   let param = Object.assign({}, this.queryParam, this.isorter)
    //   param.field = this.getQueryField()
    //   param.materialId = this.currentMaterialId
    //   param.currentPage = this.ipagination.current
    //   param.pageSize = this.ipagination.pageSize
    //   return param
    // },
    async show(e) {
      console.log(e, '上传文件内容')
      this.visible = true

      // this.dataSource = e
      if (e.uuid) {
        this.loading = true
        this.uuid = e.uuid
        const res = await gatherDetails({ uuid: e.uuid })
        if (res.code == 200) {
          this.loading = false
        }
        this.dataSource = res.data
      } else {
        this.uuid = null
        this.dataSource = e.fileList[0].response.data
        this.fileName = e.fileList[0].name
      }
      // this.model = Object.assign({}, record)
      // this.currentMaterialId = record.id
      // this.queryParam.depotIds = depotIds
      // this.queryParam.materialId = record.id
      // this.queryParam.file = e
      // this.queryParam.username = 'suming'
      // this.loadData(1)
    },
    close() {
      this.$emit('close')
      this.visible = false
      if (!this.uuid) {
        this.$emit('fatherMethod')
      }
    },
    handleCancel() {
      this.close()
    },
    onDateChange: function (value, dateString) {
      this.queryParam.beginTime = dateString[0]
      this.queryParam.endTime = dateString[1]
    },
    onDateOk(value) {
      console.log(value)
    },
    myHandleDetail(record) {
      let that = this
      this.toFromType = record.fromType
      findBillDetailByNumber({ number: record.number }).then((res) => {
        if (res && res.code === 200) {
          this.$refs.billDetail.isCanBackCheck = false
          that.$refs.billDetail.show(res.data, record.type)
          that.$refs.billDetail.title = '详情'
        }
      })
    },
    // exportExcel() {
    //   let aoa = [['单据编号', '类型', '条码', '名称', '仓库名称', '数量', '日期']]
    //   for (let i = 0; i < this.dataSource.length; i++) {
    //     let ds = this.dataSource[i]
    //     let item = [ds.number, ds.type, ds.barCode, ds.materialName, ds.depotName, ds.basicNumber, ds.operTime]
    //     aoa.push(item)
    //   }
    //   openDownloadDialog(sheet2blob(aoa), '商品库存流水')
    // },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>